// @flow
import './index.css';
import { useState } from 'react';
import Iframe from 'react-iframe';
import { IframeLoader } from '../component';
import Constants from '../constants';

const Poker = () => {
  const [loaded, setLoaded] = useState(false);

  const sendDataToPoker = () => {
    setLoaded(true);
  };

  return (
    <div className="poker__iframe__wrapper">
      <Iframe
        title={'poker'}
        allowFullScreen={true}
        url={'https://pokersoftware.gamiotech.com/direct_login'}
        id="gameIframe"
        className="gameIframe"
        onLoad={sendDataToPoker}
        // allow={'screen-wake-lock *'}
      />
      {/* ) : null}s */}
      <IframeLoader visible={!loaded} loaderImage={Constants.Images.Poker} />
    </div>
  );
};

export default Poker;
